export default __webpack_public_path__ + "static/media/trustErrorImage.bcc529d7.svg";